import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary"
      takeaways={[
        { text: "One question is confirmed from the Memory Design topic." },
        { text: "Cache topic is large but easy to understand. Don't waste time watching too many YouTube videos—get a friend to explain." },
        { text: "Theory questions are possible from Byte Storage Methods, Memory Interleaving, and Memory Hierarchy, and sometimes from Cache Write Policies (don't skip anything in Cache)." }
      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummary;
